export default __webpack_public_path__ + "static/media/hematology.e2737d3c.jpg";